// Puzzle page — chess tactics training (60+ puzzles)
import { playSound } from '../../audio/sound';
import { addPuzzleRecord } from '../../stats/store';

interface Puzzle {
  id: string;
  category: string;
  fen: string;
  solution: string[];
  description: string;
  difficulty: number;
}

const PUZZLES: Puzzle[] = [
  // ═══ MATE IN 1 (10 puzzles) ═══════════════════════════════════
  { id: 'm1-01', category: 'mate-in-1', fen: '6k1/5ppp/8/8/8/8/8/4R1K1 w - - 0 1', solution: ['e1e8'], description: 'Raja hitam di pojok, benteng ke e8 = skak mat!', difficulty: 1 },
  { id: 'm1-02', category: 'mate-in-1', fen: 'r1bqkb1r/pppp1ppp/2n2n2/4p2Q/2B1P3/8/PPPP1PPP/RNB1K1NR w KQkq - 0 1', solution: ['h5f7'], description: "Scholar's Mate! Ratu ke f7, raja terjebak.", difficulty: 1 },
  { id: 'm1-03', category: 'mate-in-1', fen: 'k7/8/1K6/8/8/8/8/1Q6 w - - 0 1', solution: ['b1a2'], description: 'Ratu ke a2, raja tidak bisa lari!', difficulty: 1 },
  { id: 'm1-04', category: 'mate-in-1', fen: '6k1/5p1p/6p1/8/7Q/8/8/6K1 w - - 0 1', solution: ['h4d8'], description: 'Ratu ke d8, back rank mate!', difficulty: 1 },
  { id: 'm1-05', category: 'mate-in-1', fen: '4k3/8/8/8/8/8/4Q3/4K3 w - - 0 1', solution: ['e2e7'], description: 'Ratu ke e7, raja terpojok!', difficulty: 1 },
  { id: 'm1-06', category: 'mate-in-1', fen: '3qk3/8/8/8/8/8/8/3QK3 w - - 0 1', solution: ['d1d8'], description: 'Mirror mate — ratu ke d8!', difficulty: 1 },
  { id: 'm1-07', category: 'mate-in-1', fen: '6k1/6pp/6Q1/8/8/8/8/4K3 w - - 0 1', solution: ['g6g7'], description: 'Ratu ke g7, mate di tengah!', difficulty: 1 },
  { id: 'm1-08', category: 'mate-in-1', fen: 'r1b2rk1/ppppqppp/2n2n2/2b1p3/2B1P3/2N2N2/PPPPQPPP/R1B1K2R w KQ - 0 1', solution: ['e2e7'], description: 'Ratu ke e7, double attack + mate!', difficulty: 1 },
  { id: 'm1-09', category: 'mate-in-1', fen: '6k1/5p2/6p1/7K/7Q/8/8/8 w - - 0 1', solution: ['h4d8'], description: 'Raja putih dekat, ratu ke d8!', difficulty: 1 },
  { id: 'm1-10', category: 'mate-in-1', fen: '2kr4/ppp5/2n5/8/8/8/8/R3K3 w Q - 0 1', solution: ['a1a8'], description: 'Benteng ke a8, back rank mate!', difficulty: 1 },

  // ═══ MATE IN 2 (10 puzzles) ═══════════════════════════════════
  { id: 'm2-01', category: 'mate-in-2', fen: 'r1bqk2r/pppp1Npp/2n2n2/2b1p3/2B1P3/8/PPPP1PPP/RNBQK2R b KQkq - 0 1', solution: ['e8f7', 'c4f7'], description: 'Kuda ke f7, skak! Raja harus ke f7, ratu mati.', difficulty: 2 },
  { id: 'm2-02', category: 'mate-in-2', fen: '2k5/8/2K5/8/8/8/8/1Q6 w - - 0 1', solution: ['b1b7', 'c8d8'], description: 'Ratu ke b7, raja ke d8, ratu ke d7 mate!', difficulty: 2 },
  { id: 'm2-03', category: 'mate-in-2', fen: 'r2qk2r/ppp2ppp/2n1bn2/2bpp3/2B1P3/2NP1N2/PPP2PPP/R1BQK2R w KQkq - 0 1', solution: ['f3g5', 'f6g4'], description: 'Kuda ke g5, serang f7! Ratu + gajah mate.', difficulty: 2 },
  { id: 'm2-04', category: 'mate-in-2', fen: 'r1b1kb1r/ppppqppp/2n2n2/4p3/2B1P3/5Q2/PPPP1PPP/RNB1K1NR w KQkq - 0 1', solution: ['f3f7', 'e8d8'], description: 'Ratu sacrifice di f7! Raja ke d8, ratu mati.', difficulty: 2 },
  { id: 'm2-05', category: 'mate-in-2', fen: '6k1/5p1p/6p1/8/8/8/8/R3K1Q1 w Q - 0 1', solution: ['g1g6', 'f7g6'], description: 'Ratu ke g6! Paksa tangkap, benteng ke a8 mate.', difficulty: 2 },
  { id: 'm2-06', category: 'mate-in-2', fen: 'r1bq2r1/pppn1pk1/2n1p2p/3p4/3P4/2N1PN2/PPP2PPP/R2QKB1R w KQ - 0 1', solution: ['d1h5', 'h6h5'], description: 'Ratu ke h5! Serang h6, mate tidak bisa dihindari.', difficulty: 2 },
  { id: 'm2-07', category: 'mate-in-2', fen: '4kb1r/p2rqppp/5n2/1Bp1N3/8/8/PPP2PPP/RNBQR1K1 w kq - 0 1', solution: ['b5d7', 'e8d7'], description: 'Gajah ke d7! Raja ke d7, ratu + kuda mate.', difficulty: 2 },
  { id: 'm2-08', category: 'mate-in-2', fen: 'r4rk1/ppp2ppp/2n5/3N4/2B1n1q1/8/PPP2PPP/R1BQ1RK1 w - - 0 1', solution: ['d5f6', 'g7f6'], description: 'Kuda ke f6! Paksa gxf6, ratu ke g4 mate.', difficulty: 2 },
  { id: 'm2-09', category: 'mate-in-2', fen: '5rk1/5ppp/8/8/8/8/5PPP/R3R1K1 w - - 0 1', solution: ['e1e8', 'f8e8'], description: 'Benteng ke e8! Rxe8, benteng a1 ke a8 mate!', difficulty: 2 },
  { id: 'm2-10', category: 'mate-in-2', fen: 'r1bqr1k1/pppn1p1p/5np1/3p4/1b1P4/2NBPN2/PP3PPP/R1BQK2R w KQ - 0 1', solution: ['h2h4', 'b4c3'], description: 'Pion h4! Ancam h5, gajah ambil c3, ratu mate.', difficulty: 2 },

  // ═══ FORK (10 puzzles) ═════════════════════════════════════════
  { id: 'fk-01', category: 'fork', fen: 'r1bqkb1r/pppp1ppp/2n2n2/4p3/2B1P3/5N2/PPPP1PPP/RNBQK2R w KQkq - 0 1', solution: ['f3g5'], description: 'Kuda ke g5! Serang f7 (raja) dan d6 sekaligus.', difficulty: 2 },
  { id: 'fk-02', category: 'fork', fen: '4k3/8/8/3N4/8/8/8/4K3 w - - 0 1', solution: ['d5c7'], description: 'Kuda ke c7! Fork raja e8 dan benteng a8!', difficulty: 1 },
  { id: 'fk-03', category: 'fork', fen: 'rnbqkbnr/pppp1ppp/8/4p3/4P3/5N2/PPPP1PPP/RNBQKB1R w KQkq - 0 1', solution: ['f3g5'], description: 'Kuda ke g5! Serang f7, paling lemah di papan.', difficulty: 1 },
  { id: 'fk-04', category: 'fork', fen: 'r1bqk2r/pppp1ppp/2n2n2/2b1p3/2B1P3/5N2/PPPP1PPP/RNBQK2R w KQkq - 0 1', solution: ['f3e5'], description: 'Kuda ke e5! Fork ratu d7 dan benteng f7.', difficulty: 2 },
  { id: 'fk-05', category: 'fork', fen: '4k3/8/8/8/3P4/8/8/4K3 w - - 0 1', solution: ['d4d5'], description: 'Pion ke d5! Bisa fork dua bidak diagonal.', difficulty: 2 },
  { id: 'fk-06', category: 'fork', fen: 'r2qk2r/ppp2ppp/2n1bn2/2bpp3/2B1P3/2NP1N2/PPP2PPP/R1BQK2R w KQkq - 0 1', solution: ['f3d4'], description: 'Kuda ke d4! Serang ratu dan benteng sekaligus.', difficulty: 2 },
  { id: 'fk-07', category: 'fork', fen: '2kr4/ppp5/2n5/3N4/8/8/8/4K3 w - - 0 1', solution: ['d5c7'], description: 'Kuda ke c7! Fork raja dan benteng!', difficulty: 1 },
  { id: 'fk-08', category: 'fork', fen: 'r1bqkbnr/pppp1ppp/2n5/4p3/2B1P3/5N2/PPPP1PPP/RNBQK2R w KQkq - 0 1', solution: ['f3g5'], description: 'Kuda ke g5! Serang f7 dan e6 sekaligus.', difficulty: 2 },
  { id: 'fk-09', category: 'fork', fen: '4k3/8/4R3/8/8/3N4/8/4K3 w - - 0 1', solution: ['d3c5'], description: 'Kuda ke c5! Fork raja dan benteng di e6.', difficulty: 2 },
  { id: 'fk-10', category: 'fork', fen: 'r3k3/8/8/3N4/8/8/8/4K3 w - - 0 1', solution: ['d5b6'], description: 'Kuda ke b6! Fork raja dan ratu!', difficulty: 2 },

  // ═══ PIN (8 puzzles) ═══════════════════════════════════════════
  { id: 'pn-01', category: 'pin', fen: '4k3/4r3/8/8/8/8/4B3/4K3 w - - 0 1', solution: ['e2b5'], description: 'Gajah ke b5! Pin kuda c6 ke raja.', difficulty: 2 },
  { id: 'pn-02', category: 'pin', fen: 'rnbqkbnr/ppp1pppp/8/3p4/3PP3/8/PPP2PPP/RNBQKBNR w KQkq d6 0 1', solution: ['f1b5'], description: 'Gajah ke b5! Pin kuda c6 ke ratu.', difficulty: 2 },
  { id: 'pn-03', category: 'pin', fen: '4k3/8/8/4n3/8/8/4B3/4K3 w - - 0 1', solution: ['e2a6'], description: 'Gajah ke a6! Pin pion ke raja.', difficulty: 2 },
  { id: 'pn-04', category: 'pin', fen: 'r1bqk2r/pppp1ppp/2n2n2/2b1p3/2B1P3/5N2/PPPP1PPP/RNBQK2R w KQkq - 0 1', solution: ['c4f7'], description: 'Gajah ke f7! Pin kuda ke raja.', difficulty: 2 },
  { id: 'pn-05', category: 'pin', fen: '4k3/4q3/8/8/8/8/4R3/4K3 w - - 0 1', solution: ['e2e4'], description: 'Benteng ke e4! Pin ratu ke raja.', difficulty: 2 },
  { id: 'pn-06', category: 'pin', fen: 'rnbqkb1r/pppppppp/5n2/8/3PP3/8/PPP2PPP/RNBQKBNR w KQkq - 0 1', solution: ['f1d3'], description: 'Gajah ke d3! Siap pin kuda f6.', difficulty: 2 },
  { id: 'pn-07', category: 'pin', fen: '4k3/8/8/3b4/8/8/4R3/4K3 w - - 0 1', solution: ['e2e4'], description: 'Benteng ke e4! Pin gajah ke raja.', difficulty: 2 },
  { id: 'pn-08', category: 'pin', fen: 'r1bqkbnr/pppp1ppp/2n5/4p3/2B1P3/5N2/PPPP1PPP/RNBQK2R w KQkq - 0 1', solution: ['c4f7'], description: 'Gajah ke f7! Pin dan serang raja.', difficulty: 2 },

  // ═══ SKEWER (8 puzzles) ════════════════════════════════════════
  { id: 'sk-01', category: 'skewer', fen: '4k3/8/8/8/8/8/8/B3K3 w - - 0 1', solution: ['a1e5'], description: 'Gajah ke e5! Skewer raja, benteng di belakang.', difficulty: 2 },
  { id: 'sk-02', category: 'skewer', fen: '4k3/4R3/8/8/8/8/8/4K3 w - - 0 1', solution: ['e7e8'], description: 'Benteng ke e8! Skewer raja ke pinggir.', difficulty: 1 },
  { id: 'sk-03', category: 'skewer', fen: '1k6/8/8/8/8/8/8/B3K3 w - - 0 1', solution: ['a1d4'], description: 'Gajah ke d4! Skewer raja ke benteng.', difficulty: 2 },
  { id: 'sk-04', category: 'skewer', fen: 'r3k3/8/8/8/8/8/8/4K2R w K - 0 1', solution: ['h1h8'], description: 'Benteng ke h8! Skewer raja ke benteng a8.', difficulty: 1 },
  { id: 'sk-05', category: 'skewer', fen: '4k3/8/8/8/1q6/8/8/R3K3 w Q - 0 1', solution: ['a1a8'], description: 'Benteng ke a8! Skewer raja ke ratu.', difficulty: 2 },
  { id: 'sk-06', category: 'skewer', fen: '4k3/4r3/8/8/8/8/4R3/4K3 w - - 0 1', solution: ['e2e7'], description: 'Benteng ke e7! Tukar benteng, posisi menang.', difficulty: 2 },
  { id: 'sk-07', category: 'skewer', fen: 'r3k3/8/8/8/8/8/8/3QK3 w - - 0 1', solution: ['d1d8'], description: 'Ratu ke d8! Skewer raja ke benteng.', difficulty: 1 },
  { id: 'sk-08', category: 'skewer', fen: '4k3/8/8/8/8/5b2/8/4K2R w K - 0 1', solution: ['h1h8'], description: 'Benteng ke h8! Skewer raja ke gajah.', difficulty: 2 },

  // ═══ DISCOVERED ATTACK (8 puzzles) ══════════════════════════════
  { id: 'da-01', category: 'discovered-attack', fen: '4k3/8/8/4B3/4P3/8/8/4K3 w - - 0 1', solution: ['e4e5'], description: 'Pion ke e5! Buka jalur gajah ke raja.', difficulty: 2 },
  { id: 'da-02', category: 'discovered-attack', fen: 'rnbqkbnr/pppppppp/8/8/4P3/8/PPPP1PPP/RNBQKBNR w KQkq e3 0 1', solution: ['e4e5'], description: 'Pion ke e5! Buka jalur gajah f1.', difficulty: 2 },
  { id: 'da-03', category: 'discovered-attack', fen: '4k3/4r3/8/4B3/8/4P3/8/4K3 w - - 0 1', solution: ['e3e4'], description: 'Pion ke e4! Buka gajah ke benteng.', difficulty: 2 },
  { id: 'da-04', category: 'discovered-attack', fen: '4k3/8/8/3N4/8/8/4B3/4K3 w - - 0 1', solution: ['d5e3'], description: 'Kuda ke e3! Buka gajah ke raja.', difficulty: 2 },
  { id: 'da-05', category: 'discovered-attack', fen: 'r1bqk2r/pppp1ppp/2n2n2/2b1p3/2B1P3/5N2/PPPP1PPP/RNBQK2R w KQkq - 0 1', solution: ['f3e5'], description: 'Kuda ke e5! Buka gajah c4 ke f7.', difficulty: 2 },
  { id: 'da-06', category: 'discovered-attack', fen: '4k3/8/4R3/4N3/8/8/8/4K3 w - - 0 1', solution: ['e5d3'], description: 'Kuda ke d3! Buka benteng ke raja.', difficulty: 2 },
  { id: 'da-07', category: 'discovered-attack', fen: '4k3/4q3/8/4B3/4P3/8/8/4K3 w - - 0 1', solution: ['e4e5'], description: 'Pion ke e5! Buka gajah ke ratu.', difficulty: 2 },
  { id: 'da-08', category: 'discovered-attack', fen: 'rnbqkb1r/pppppppp/5n2/8/3PP3/8/PPP2PPP/RNBQKBNR w KQkq - 0 1', solution: ['d4d5'], description: 'Pion ke d5! Buka ratu ke gajah c8.', difficulty: 2 },

  // ═══ BACK RANK MATE (8 puzzles) ═════════════════════════════════
  { id: 'br-01', category: 'back-rank', fen: '6k1/5ppp/8/8/8/8/8/R3K3 w - - 0 1', solution: ['a1a8'], description: 'Benteng ke a8! Raja terjebak di baris belakang.', difficulty: 1 },
  { id: 'br-02', category: 'back-rank', fen: '2kr4/ppp5/2n5/8/8/8/8/R3K3 w Q - 0 1', solution: ['a1a8'], description: 'Benteng ke a8! Raja tidak bisa keluar.', difficulty: 1 },
  { id: 'br-03', category: 'back-rank', fen: '1k1r4/ppp5/2n5/8/8/8/8/R3K3 w Q - 0 1', solution: ['a1a8'], description: 'Benteng ke a8! Back rank mate klasik.', difficulty: 1 },
  { id: 'br-04', category: 'back-rank', fen: '6k1/5ppp/8/8/8/8/5PPP/R3K3 w - - 0 1', solution: ['a1a8'], description: 'Benteng ke a8! Pion sendiri blok raja.', difficulty: 1 },
  { id: 'br-05', category: 'back-rank', fen: '1k6/ppp5/8/8/8/8/8/R3K3 w - - 0 1', solution: ['a1a8'], description: 'Benteng ke a8! Raja di pojok.', difficulty: 1 },
  { id: 'br-06', category: 'back-rank', fen: '2kr4/ppp2ppp/2n5/8/8/8/PPP2PPP/R3K3 w Q - 0 1', solution: ['a1a8'], description: 'Benteng ke a8! Pion menghalangi raja.', difficulty: 1 },
  { id: 'br-07', category: 'back-rank', fen: 'r3k3/ppp2ppp/8/8/8/8/PPP2PPP/R3K3 w Qq - 0 1', solution: ['a1a8'], description: 'Benteng ke a8! Mutual back rank.', difficulty: 1 },
  { id: 'br-08', category: 'back-rank', fen: '6k1/5ppp/6Q1/8/8/8/8/R3K3 w - - 0 1', solution: ['a1a8'], description: 'Benteng ke a8! Ratu + benteng combo.', difficulty: 1 },

  // ═══ SACRIFICE (8 puzzles) ══════════════════════════════════════
  { id: 'sa-01', category: 'sacrifice', fen: 'r1bqkb1r/pppp1ppp/2n2n2/4p3/2B1P3/5Q2/PPPP1PPP/RNB1K1NR w KQkq - 0 1', solution: ['f3f7'], description: 'Ratu sacrifice f7! Raja harus tangkap, lalu Bxf7 mate.', difficulty: 3 },
  { id: 'sa-02', category: 'sacrifice', fen: 'r1bqk2r/pppp1ppp/2n2n2/2b1p3/2B1P3/5N2/PPPP1PPP/RNBQK2R w KQkq - 0 1', solution: ['f3g5', 'f7g5'], description: 'Kuda ke g5! Sacrifice, buka jalur ratu ke f7.', difficulty: 3 },
  { id: 'sa-03', category: 'sacrifice', fen: '4k3/8/8/8/8/8/4Q3/4K3 w - - 0 1', solution: ['e2e7', 'e8e7'], description: 'Ratu ke e7! Paksa raja tangkap, posisi menang.', difficulty: 2 },
  { id: 'sa-04', category: 'sacrifice', fen: 'r1bq1rk1/pppp1ppp/2n2n2/2b1p3/2B1P3/2N2N2/PPPP1PPP/R1BQK2R w KQ - 0 1', solution: ['f3g5'], description: 'Kuda ke g5! Threat Ng5xf7, sacrifice pembuka.', difficulty: 3 },
  { id: 'sa-05', category: 'sacrifice', fen: 'r2qk2r/ppp2ppp/2n1bn2/2bpp3/2B1P3/2NP1N2/PPP2PPP/R1BQK2R w KQkq - 0 1', solution: ['c4f7', 'e8f7'], description: 'Gajah sacrifice f7! Buka raja, serangan dahsyat.', difficulty: 3 },
  { id: 'sa-06', category: 'sacrifice', fen: '4k3/8/8/3R4/8/8/8/4K3 w - - 0 1', solution: ['d5d8', 'e8d8'], description: 'Benteng ke d8! Sacrifice, raja ke d8, raja putih aktif.', difficulty: 2 },
  { id: 'sa-07', category: 'sacrifice', fen: 'r1bqkbnr/pppp1ppp/2n5/4p3/2B1n3/5N2/PPPP1PPP/RNBQK2R w KQkq - 0 1', solution: ['c4f7', 'e8f7'], description: 'Gajah sacrifice! Buka raja, kuda + ratu serang.', difficulty: 3 },
  { id: 'sa-08', category: 'sacrifice', fen: '6k1/5p1p/6p1/8/7Q/8/8/4K3 w - - 0 1', solution: ['h4h7', 'g8h7'], description: 'Ratu sacrifice h7! Paksa raja keluar, mate datang.', difficulty: 3 },
];

const CATEGORIES = [
  { id: 'mate-in-1', name: 'Mate in 1', icon: '⚔️', desc: 'Satu langkah = menang' },
  { id: 'mate-in-2', name: 'Mate in 2', icon: '🗡️', desc: 'Dua langkah ke checkmate' },
  { id: 'fork', name: 'Fork', icon: '🍴', desc: 'Serang dua bidak sekaligus' },
  { id: 'pin', name: 'Pin', icon: '📌', desc: 'Jepit bidak lawan' },
  { id: 'skewer', name: 'Skewer', icon: '🍢', desc: 'Tusuk dari depan' },
  { id: 'discovered-attack', name: 'Discovery', icon: '💥', desc: 'Buka jalur serangan' },
  { id: 'back-rank', name: 'Back Rank', icon: '🏰', desc: 'Mate baris belakang' },
  { id: 'sacrifice', name: 'Sacrifice', icon: '💎', desc: 'Korbankan untuk menang' },
];

let currentPuzzle: Puzzle | null = null;
let solutionIndex = 0;
let selectedSquare: string | null = null;
let puzzleAttempts = 0;

export function renderPuzzle(): string {
  return `
    <div class="puzzle-page">
      <h1 class="page-title">🧩 Puzzle</h1>
      <p class="text-secondary mb-lg">68 puzzle taktik catur — latih otakmu!</p>

      <div id="puzzle-categories" class="grid-2">
        ${CATEGORIES.map(cat => {
          const count = PUZZLES.filter(p => p.category === cat.id).length;
          return `
            <div class="card puzzle-category" data-category="${cat.id}">
              <div class="puzzle-cat-icon">${cat.icon}</div>
              <div class="puzzle-cat-name">${cat.name}</div>
              <div class="puzzle-cat-count text-secondary">${count} puzzle</div>
              <div class="puzzle-cat-desc">${cat.desc}</div>
            </div>
          `;
        }).join('')}
      </div>

      <div id="puzzle-game" style="display:none">
        <button class="btn btn-ghost btn-sm mb-md" id="btn-back-puzzles">← Kembali</button>
        <div class="puzzle-header">
          <span class="puzzle-category-label" id="puzzle-cat-label"></span>
          <span class="puzzle-counter text-secondary" id="puzzle-counter"></span>
        </div>
        <div class="puzzle-description card mb-md" id="puzzle-desc"></div>
        <div class="board-container">
          <div class="board-wrapper" id="puzzle-board" style="width:min(85vw,400px);height:min(85vw,400px)"></div>
          <div class="puzzle-feedback" id="puzzle-feedback">Cari langkah terbaik!</div>
          <div class="game-controls">
            <button class="btn btn-ghost btn-sm" id="btn-puzzle-hint">💡 Hint</button>
            <button class="btn btn-ghost btn-sm" id="btn-puzzle-reset">🔄 Ulang</button>
            <button class="btn btn-primary btn-sm" id="btn-puzzle-next">Selanjutnya →</button>
          </div>
        </div>
      </div>
    </div>
  `;
}

export function initPuzzle(): void {
  document.querySelectorAll('.puzzle-category').forEach(cat => {
    cat.addEventListener('click', () => {
      const categoryId = (cat as HTMLElement).dataset.category;
      openCategory(categoryId!);
    });
  });

  document.getElementById('btn-back-puzzles')?.addEventListener('click', closePuzzle);
  document.getElementById('btn-puzzle-hint')?.addEventListener('click', showHint);
  document.getElementById('btn-puzzle-reset')?.addEventListener('click', resetPuzzle);
  document.getElementById('btn-puzzle-next')?.addEventListener('click', nextPuzzle);
}

function openCategory(categoryId: string): void {
  const puzzles = PUZZLES.filter(p => p.category === categoryId);
  if (puzzles.length === 0) return;

  currentPuzzle = puzzles[Math.floor(Math.random() * puzzles.length)];
  solutionIndex = 0;
  puzzleAttempts = 0;

  document.getElementById('puzzle-categories')!.style.display = 'none';
  document.getElementById('puzzle-game')!.style.display = 'block';

  const category = CATEGORIES.find(c => c.id === categoryId);
  document.getElementById('puzzle-cat-label')!.textContent = category ? `${category.icon} ${category.name}` : '';
  updatePuzzleCounter();

  renderPuzzleBoard();
}

function closePuzzle(): void {
  currentPuzzle = null;
  document.getElementById('puzzle-categories')!.style.display = 'grid';
  document.getElementById('puzzle-game')!.style.display = 'none';
}

function updatePuzzleCounter(): void {
  if (!currentPuzzle) return;
  const puzzles = PUZZLES.filter(p => p.category === currentPuzzle!.category);
  const idx = puzzles.findIndex(p => p.id === currentPuzzle!.id);
  document.getElementById('puzzle-counter')!.textContent = `${idx + 1} / ${puzzles.length}`;
}

function renderPuzzleBoard(): void {
  if (!currentPuzzle) return;

  document.getElementById('puzzle-desc')!.textContent = currentPuzzle.description;
  document.getElementById('puzzle-feedback')!.textContent = '🔍 Cari langkah terbaik!';
  document.getElementById('puzzle-feedback')!.className = 'puzzle-feedback';

  const boardEl = document.getElementById('puzzle-board');
  if (!boardEl) return;

  const ranks = currentPuzzle.fen.split(' ')[0].split('/');
  const PIECE_MAP: Record<string, string> = {
    'K': '♔', 'Q': '♕', 'R': '♖', 'B': '♗', 'N': '♘', 'P': '♙',
    'k': '♚', 'q': '♛', 'r': '♜', 'b': '♝', 'n': '♞', 'p': '♟',
  };

  let html = '<table class="board-table"><tbody>';
  for (let r = 0; r < 8; r++) {
    html += '<tr>';
    let col = 0;
    for (const ch of ranks[r]) {
      if (ch >= '1' && ch <= '9') {
        for (let i = 0; i < parseInt(ch); i++) {
          const isLight = (r + col) % 2 === 0;
          html += `<td class="square ${isLight ? 'light' : 'dark'}" data-square="${String.fromCharCode(97 + col)}${8 - r}"></td>`;
          col++;
        }
      } else {
        const isLight = (r + col) % 2 === 0;
        const piece = PIECE_MAP[ch] || '';
        html += `<td class="square ${isLight ? 'light' : 'dark'}" data-square="${String.fromCharCode(97 + col)}${8 - r}">${piece}</td>`;
        col++;
      }
    }
    html += '</tr>';
  }
  html += '</tbody></table>';
  boardEl.innerHTML = html;

  boardEl.querySelectorAll('.square').forEach(sq => {
    sq.addEventListener('click', () => handlePuzzleClick(sq as HTMLElement));
  });
}

function handlePuzzleClick(sq: HTMLElement): void {
  if (!currentPuzzle) return;
  if (solutionIndex >= currentPuzzle.solution.length) return;

  const square = sq.dataset.square!;

  if (selectedSquare) {
    const move = `${selectedSquare}${square}`;
    const expectedMove = currentPuzzle.solution[solutionIndex];

    if (move === expectedMove) {
      playSound('move');
      sq.classList.add('correct');
      solutionIndex++;

      if (solutionIndex >= currentPuzzle.solution.length) {
        playSound('achievement');
        document.getElementById('puzzle-feedback')!.textContent = '🎉 Benar! Puzzle selesai!';
        document.getElementById('puzzle-feedback')!.className = 'puzzle-feedback success';

        addPuzzleRecord({
          puzzleId: currentPuzzle.id,
          category: currentPuzzle.category,
          solved: true,
          attempts: puzzleAttempts + 1,
          solvedAt: new Date().toISOString(),
        });
      } else {
        document.getElementById('puzzle-feedback')!.textContent = '✅ Benar! Sekarang cari langkah selanjutnya...';
        document.getElementById('puzzle-feedback')!.className = 'puzzle-feedback info';
        updatePuzzleBoard(expectedMove);
      }
    } else {
      puzzleAttempts++;
      playSound('check');
      document.getElementById('puzzle-feedback')!.textContent = `❌ Kurang tepat! (percobaan ke-${puzzleAttempts})`;
      document.getElementById('puzzle-feedback')!.className = 'puzzle-feedback error';
      sq.classList.add('wrong');
      setTimeout(() => sq.classList.remove('wrong'), 500);
    }

    clearPuzzleSelection();
  } else {
    selectedSquare = square;
    sq.classList.add('selected');
  }
}

function updatePuzzleBoard(_move: string): void {
  renderPuzzleBoard();
}

function clearPuzzleSelection(): void {
  selectedSquare = null;
  document.querySelectorAll('#puzzle-board .selected').forEach(el => el.classList.remove('selected'));
}

function showHint(): void {
  if (!currentPuzzle) return;
  const expectedMove = currentPuzzle.solution[solutionIndex];
  const fromSquare = expectedMove.slice(0, 2);
  const el = document.querySelector(`#puzzle-board [data-square="${fromSquare}"]`);
  if (el) {
    el.classList.add('hint');
    setTimeout(() => el.classList.remove('hint'), 2000);
  }
  document.getElementById('puzzle-feedback')!.textContent = '💡 Lihat kotak yang berkedip!';
}

function resetPuzzle(): void {
  if (!currentPuzzle) return;
  solutionIndex = 0;
  puzzleAttempts = 0;
  renderPuzzleBoard();
}

function nextPuzzle(): void {
  if (!currentPuzzle) return;
  const puzzles = PUZZLES.filter(p => p.category === currentPuzzle!.category && p.id !== currentPuzzle!.id);
  if (puzzles.length > 0) {
    currentPuzzle = puzzles[Math.floor(Math.random() * puzzles.length)];
    solutionIndex = 0;
    puzzleAttempts = 0;
    updatePuzzleCounter();
    renderPuzzleBoard();
  } else {
    document.getElementById('puzzle-feedback')!.textContent = '🏆 Semua puzzle selesai! Coba kategori lain.';
  }
}
